
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4690_3233)"}},[_c('path',{attrs:{"d":"M14 .72a.722.722 0 00-.72-.72h-3.05v5.385a.538.538 0 01-.738.5l-2.138-.856a.946.946 0 00-.708 0l-2.138.856a.54.54 0 01-.739-.5V0H.721A.722.722 0 000 .72V13.28c0 .398.323.72.72.72H13.28c.398 0 .72-.322.72-.72V.72H14zM2.154 9.155h2.154a.538.538 0 110 1.077H2.154a.538.538 0 110-1.077zm4.308 3.23H2.154a.538.538 0 110-1.076h4.308a.538.538 0 110 1.077z"}}),_c('path',{attrs:{"d":"M9.308 0v4.59l-1.4-.56a2.02 2.02 0 00-1.508 0L5 4.59V0h4.308z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4690_3233"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    